export const SET_PAST_ORDERS = 'SET_PAST_ORDERS'
export const SET_FUTURE_ORDERS = 'SET_FUTURE_ORDERS'
export const SET_LOADING = 'SET_LOADING'
export const SET_COUNT = 'SET_COUNT'
export const SET_LOCATION = 'SET_LOCATION'
export const SET_CURRENT_PAST_ORDER_COUNT = 'SET_CURRENT_PAST_ORDER_COUNT'
export const SET_PAST_PAGE = 'SET_PAST_PAGE'
export const SET_FUTURE_PAGE = 'SET_FUTURE_PAGE'
